import * as React from "react";
import Text from "@warda/library-ui/core/Text";
import { getFileTypeText } from "../utils";
const ViewListHeader = ({ type, filesTotal }) => (React.createElement("div", { style: {
        flex: 1,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    } },
    React.createElement(Text, { ellipsis: true, weight: "bolder", style: { marginLeft: 20, flex: 1 }, children: String(filesTotal[type]) + " " + getFileTypeText(type) })));
export default ViewListHeader;
